function centerSearch() {
  // Vertically center the search bar
  var viewportHeight = window.innerHeight;
  var viewportWidth = window.innerWidth;
  $('.overlay-content').css('top', viewportHeight/2);
}

/**
 * jQuery Typeahead plugin
 */

$(document).ready(function () {

  centerSearch();

  // Watch the overlay's visibility property
  var searchOverlay  = document.querySelector('#searchOverlay');

  var observer = new MutationObserver( function(mutations){
    mutations.forEach(function(mutation){

        if( window.getComputedStyle(searchOverlay).getPropertyValue( 'display' ) !== 'none')
        {
          $('body').addClass('noscroll');
          centerSearch();
          $('#searchOverlay input').val('');
        }

        if( window.getComputedStyle(searchOverlay).getPropertyValue( 'display' ) === 'none')
        {
          $('body').removeClass('noscroll');
        }
    });
 });

 observer.observe(searchOverlay, { attributes: true } );

  // Search overlay
  $('.search-toggle').on("click", function () {
    $('#searchOverlay').fadeIn(200, function () {
      $('#searchOverlay input').focus();
    });
  });

  $('#searchOverlay .closebtn').on("click", function () {
    $('#searchOverlay').fadeOut(200);
  });

  // If user clicks outside the form elements, hide overlay
  $(document).mouseup(function(e)
    {
      var container = $('#searchOverlay');

      // if the target of the click isn't the container nor a descendant of the container
      if (!$('.overlay-content').is(e.target) && container.has(e.target).length === 0)
      {
          container.fadeOut(200);
      }
  });

  // Hit esc to close modal
  $(document).keyup(function(e) {
    if (e.keyCode === 27) $('#searchOverlay').fadeOut(200);   // esc
  });

  var itemLimit = 7;
  var totalResults = 0;

   $('.js-typeahead').typeahead({
      // input: '.js-typeahead',
      highlight: true,
      cancelButton: false,
      debug: false,
      dynamic: true,
      delay: 1000,
      filter: false,
      group: true,
      loadingAnimation: true,
      minLength: 2,
      maxItem: 0,
      maxItemPerGroup: itemLimit,
      // async: true,
      source: {
        topics: {
          display: "value",
          template: "{{value}}",
          href: "/topics/{{id}}",
          ajax: function (query) {
            return {
              type: "GET",
              url: "/data/search/topics/",
              data: {
                q: "{{query}}",
              },
            }
          }
        },
        articles: {
          display: "topic",
          // template: "See {{count}} articles",
          template: function (query, item) {
            item.count = item.count.toLocaleString();
            return "See all " + item.count + " articles";
          },
          href: "/search/?q={{topic}}",
          ajax: function (query) {
            return {
              type: "GET",
              url: "/data/search/articles/",
              data: {
                q: "{{query}}",
              },
            }
          }
        },
      },
      callback: {
       onInit: function (node) {
          // console.log('Typeahead initiated on ' + node[0].selector);
        },
       onReady: function (node) {
          // console.log('Typeahead ready');
        },
       onResult: function (node, query, result, resultCount) {
         // Grab the viewport height
         var viewportHeight = window.innerHeight;

         // Set parent variable counter
         totalResults = resultCount;

         // Because resultCount is used to calculate position of the container,
         // we need to make sure it doesn't get too big
         if (resultCount>itemLimit) {
           resultCount=itemLimit;
         }

         var newPosition = (viewportHeight/2)-((resultCount * 40)/2);
         $('.overlay-content').animate({'top': newPosition}, 400, "easeOutQuint", function () {
           // animation complete
         });
       },
       onSendRequest: function (node, query) {

       },
       onSubmit: function (node, form, item, event) {
         // console.log('onSubmit fired');
         // form.submit();
       },
       onLayoutBuiltBefore: function (node, query, result, resultHtmlList) {
         if (result.length > 0) {
           var insertItem = '<li class="typeahead__item typeahead__group-topics"><a href="/search/?q='+query+'">See all '+(totalResults-1)+' topics</a></li>';
           resultHtmlList.find('.typeahead__item:nth-child('+(itemLimit+1)+')').after(insertItem);
         }
       }
      }
  });

}); // document ready
